module.exports = __webpack_public_path__ + "img/head_guarantee_299.c67de6d3.png";